import { render, staticRenderFns } from "./question-3.vue?vue&type=template&id=4a2f20b1&scoped=true"
import script from "./question-3.vue?vue&type=script&lang=js"
export * from "./question-3.vue?vue&type=script&lang=js"
import style0 from "./question-3.vue?vue&type=style&index=0&id=4a2f20b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2f20b1",
  null
  
)

export default component.exports